import { useCIQMutation, useCIQQuerySubscription } from "hooks/ciq-gql-hooks";
import { useContext, useEffect, useState } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { gql } from "@apollo/client";
import { MUTATION_CREATE_FEATURE_INSTANCE } from "entity-app/graphQL/ciq-feature-mutations";
import { message } from "antd";
import { MaterialExtractSpecType } from "../model";
import { QUERY_MATERIAL_EXTRACTED_DATA } from "../queries";

export const useMaterialLogData = () => {
  const {
    gqlClientForProject,

    columnHeaders: { materialHeaderMap }
  } = useContext(ProjectContext);

  const [entityList, setEntityList] =
    useState<Array<MaterialExtractSpecType>>();
  const [entityListLoading, setEntityListLoading] = useState(false);
  const [entityListLoadedOnce, setEntityListLoadedOnce] = useState(false);

  const { data: materialExtractionData } = useCIQQuerySubscription<{
    extraction_data: Array<MaterialExtractSpecType>;
  }>(QUERY_MATERIAL_EXTRACTED_DATA, {
    client: gqlClientForProject,
    skip: !gqlClientForProject
  });

  useEffect(() => {
    if (materialExtractionData && materialExtractionData.extraction_data) {
      setEntityList(materialExtractionData.extraction_data);
      setEntityListLoadedOnce(true);
      setEntityListLoading(false);
    }
    return () => {};
  }, [materialExtractionData]);

  const [createEntityMutation] = useCIQMutation(
    gql(MUTATION_CREATE_FEATURE_INSTANCE),
    {
      client: gqlClientForProject
    }
  );

  const addMaterialsInLog = async (selectedRows: MaterialExtractSpecType[]) => {
    if (!selectedRows) return;

    const objects = selectedRows.map((m) => {
      return {
        extraction_data_id: m.id,
        title: m.title,
        tag_name: m.tag,
        manufacturer: m.manufacturer
      };
    });

    if (objects && objects?.length) {
      const variables = {
        feature_type: "MATERIALS",
        feature_instances: objects
      };
      const creatResponse: any = await createEntityMutation({
        variables
      });

      if (creatResponse?.data?.insert_feature_instances_multi?.ids?.length) {
        const numberOfMaterial =
          creatResponse?.data?.insert_feature_instances_multi?.ids?.length;
        message.success(`${numberOfMaterial} materials were added to the log.`);
        // refetch();
      } else {
        message.error("Unable to create Material.");
      }
    }
  };

  return {
    entityList,
    setEntityList,
    entityListLoading,
    entityListLoadedOnce,
    materialHeaderMap,
    addMaterialsInLog
  };
};
